import React from 'react';
import { TableRow, TableCell, Checkbox } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const LoadingItem: React.FC = () => {
  return (
    <TableRow>
      <TableCell>
        <Skeleton animation="wave" />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell component="th" scope="row">
        <Checkbox color="primary" disabled />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
      <TableCell>
        <Skeleton animation="wave" height={35} />
      </TableCell>
    </TableRow>
  );
};

export default LoadingItem;
